module.exports = __webpack_public_path__ + "img/modifications--with_i_drive.50102941.png";